// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control-label[data-v-4f09db0d] {\n  padding-left: 0px;\n}\n.form-control-label h4[data-v-4f09db0d] {\n  margin-bottom: 0.5em;\n}", ""]);
// Exports
module.exports = exports;
